import React from "react";
import logo from "../images/logo.png";

export default function SlimmingDoctorInfo() {
  return (
    <div className=" bg-white flex items-center justify-center px-4  font-Poppins text-[#000000]">

      <div className="w-full  rounded-2xl shadow-sm pt-4  relative">

        {/* <button
          type="button"
          className="absolute left-[1.75rem] top-[2rem] text-[#000000] text-2xl leading-none"
          onClick={() => window.history.back()}
        >
          ←
        </button> */}

        {/* <div className="flex justify-center mt-2 mb-8">
          <img
            src={logo}
            alt="Slimming Doctor"
            className="h-12 sm:h-14 object-contain"
          />
        </div> */}

        <section className="mb-6">
          <h2 className="text-[16px] font-Medium text-[#000000] mb-3">
            How does Slimming Doctor work?
          </h2>
          <ol className="list-decimal pl-5 space-y-1 text-[14px] text-[#000000]">
            <li>Complete an online self-assessment.</li>
            <li>Receive your medications and begin your slimming journey.</li>
            <li>
              Have regular check-ins with our weight loss doctor to keep you on
              track.
            </li>
            <li>
              Once you reach your goal, your doctor will guide you through a
              personalised maintenance plan.
            </li>
          </ol>
        </section>

        <div className="border-t border-gray-200 my-4" />

        <section>
          <h3 className="text-[16px] font-Medium text-[#000000] mb-3">
            Benefits of working with Slimming Doctor
          </h3>

          <div className="mb-2">
            <select
              className="w-full border border-gray-200 rounded-md bg-white px-4 py-3 text-sm text-[#000000] focus:outline-none"
            >
              <option value="">Cutting Edge medications under Expert Guidance</option>
              <option value="medication-types">Types of medications we use</option>
              <option value="doctor-guidance">How doctors guide the treatment</option>
              <option value="results">Expected results</option>
            </select>
          </div>

          <div className="mb-2">
            <select
              className="w-full border border-gray-200 rounded-md bg-white px-4 py-3 text-sm text-[#000000] focus:outline-none"
            >
              <option value="">Safety</option>
              <option value="side-effects">Understanding side effects</option>
              <option value="monitoring">Ongoing medical monitoring</option>
              <option value="emergency">When to seek help</option>
            </select>
          </div>

          <div className="mb-2">
            <select
              className="w-full border border-gray-200 rounded-md bg-white px-4 py-3 text-sm text-[#000000] focus:outline-none"
            >
              <option value="">Accountability</option>
              <option value="checkins">Weekly check-ins</option>
              <option value="tracking">Progress tracking</option>
              <option value="support">Continuous support</option>
            </select>
          </div>

          <div className="mb-5">
            <select
              className="w-full border border-gray-200 rounded-md bg-white px-4 py-3 text-sm text-[#000000] focus:outline-none"
            >
              <option value="">Long-term Success</option>
              <option value="lifestyle">Lifestyle coaching</option>
              <option value="maintenance">Maintenance plans</option>
              <option value="relapse-prevention">Relapse prevention</option>
            </select>
          </div>

        </section>
        <button
          type="button"
          className="w-[60%] border border-[#35C3D9] text-[#35C3D9] rounded-md py-3 text-[14px] font-medium bg-white hover:bg-[#E6F7FA] transition"
        >
          Compare Us vs. Other Providers
        </button>
      </div>
    </div>
  );
};


